import React from "react";
import "./All_Services.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const All_Services = () => {
  return (
    <section className="All_Services">
      <div className="container">
        <div className="services_Outer_card">
          <div className="row">
            <div className="col-md-7">
              <Link
                to={{
                  pathname: "/services-inner/1",
                  state: {
                    tabKey: "Video_Wala_Bus_Stand", 
                  },
                }}
              >
                <div className="main_img_content_holder main_card_holder ">
                  <div className="img_holder">
                    <img
                      className="services_Outer_card_img"
                      src={
                        process.env.PUBLIC_URL +
                        "/Assets/Images/Service/Sevices_Outer/vdowala.png"
                      }
                    />
                  </div>
                  <div className="main_border_vdo_wala_text_holder">
                    <div className="vdo_wala_text_holder">
                      <h4>Videowala Bus Stand</h4>
                      <p>
                        is a game - changing advertising platform offered by
                        ReachOut Media, designed to help businesses connect with
                        millions of potential customers daily.
                      </p>
                      <Link to={"/services-inner/1"}>
                        <span>READ MORE</span>
                      </Link>
                    </div>
                  </div>

                  <div className="arrow_holder">
                    <FontAwesomeIcon
                      className="top_left_arrow"
                      icon={faArrowRight}
                    />
                  </div>

                  <div className="overlay_holder"></div>
                </div>
              </Link>
            </div>

            <div className="col-md-5">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-6">
                  <div className="col-md-12 col-sm-12 col-12">
                    <Link
                      to={{
                        pathname: "/services-inner/2",
                        state: {
                          tabKey: "Multimedia_Advertising", 
                        },
                      }}
                    >
                      <div className="main_img_content_holder big_img">
                        <div className="img_holder ">
                          <img
                            className="services_Outer_card_img"
                            src={
                              process.env.PUBLIC_URL +
                              "/Assets/Images/Service/Sevices_Outer/advertise.png"
                            }
                          />
                        </div>
                        <div className="text_holder">
                          <p>
                            Multimedia <br /> Advertising
                          </p>
                        </div>

                        <div className="arrow_holder">
                          <FontAwesomeIcon
                            className="top_left_arrow"
                            icon={faArrowRight}
                          />
                        </div>

                        <div className="overlay_holder"></div>
                      </div>
                    </Link>
                  </div>

                  <div className="col-md-12 col-sm-12 col-12">
                    <Link to={"/services-inner/3"}>
                      <div className="main_img_content_holder small_img">
                        <div className="img_holder ">
                          <img
                            className="services_Outer_card_img"
                            src={
                              process.env.PUBLIC_URL +
                              "/Assets/Images/Service/Sevices_Outer/digital.png"
                            }
                          />
                        </div>
                        <div className="text_holder">
                          <p>Digital Media</p>
                        </div>

                        <div className="arrow_holder">
                          <FontAwesomeIcon
                            className="top_left_arrow"
                            icon={faArrowRight}
                          />
                        </div>

                        <div className="overlay_holder"></div>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-6">
                  <div className="col-md-12 col-sm-12 col-12">
                    {/* <Link to={"/services-inner/4"}> */}
                      <div className="main_img_content_holder small_img">
                        {/* <div className="img_holder ">
                          <img
                            className="services_Outer_card_img"
                            src={
                              process.env.PUBLIC_URL +
                              "/Assets/Images/Service/Sevices_Outer/print.png"
                            }
                          />
                        </div> */}
                        {/* <div className="text_holder">
                          <p>Print Media</p>
                        </div> */}

                        {/* <div className="arrow_holder">
                          <FontAwesomeIcon
                            className="top_left_arrow"
                            icon={faArrowRight}
                          />
                        </div> */}

                        {/* <div className="overlay_holder"></div> */}
                      </div>
                    {/* </Link> */}
                  </div>

                  <div className="col-md-12 col-sm-12 col-12">
                    <Link to={"/services-inner/5"}>
                      <div className="main_img_content_holder big_img">
                        <div className="img_holder ">
                          <img
                            className="services_Outer_card_img "
                            src={
                              process.env.PUBLIC_URL +
                              "/Assets/Images/Service/Sevices_Outer/brand.png"
                            }
                          />
                        </div>
                        <div className="text_holder">
                          <p>Branding</p>
                        </div>

                        <div className="arrow_holder">
                          <FontAwesomeIcon
                            className="top_left_arrow"
                            icon={faArrowRight}
                          />
                        </div>

                        <div className="overlay_holder"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default All_Services;
